import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const SummaryCards = ({
  totalTasks,
  mediumTasks,
  highTasks,
  topTasks,
  lowTasks,
  filterTask,
}) => {
  return (
    <Row lg={5} className="mb-4">
      <Col md={3}>
        <div onClick={() => filterTask("All")} className="bento-card logo">
          <div className="bento-card-description">
            <h2>Total Tasks</h2>
            <p>{totalTasks}</p>
          </div>
        </div>
      </Col>

      <Col md={3}>
        <div onClick={() => filterTask("Top")} className="bento-card logo">
          <div className="bento-card-description">
            <h2>Top</h2>
            <p className="topcolor">{topTasks}</p>
          </div>
        </div>
      </Col>

      <Col md={3}>
        <div onClick={() => filterTask("High")} className="bento-card logo">
          <div className="bento-card-description">
            <h2>High</h2>
            <p className="highcolor">{highTasks}</p>
          </div>
        </div>
      </Col>

      <Col md={3}>
        <div onClick={() => filterTask("Medium")} className="bento-card logo">
          <div className="bento-card-description">
            <h2>Medium</h2>
            <p className="mediumcolor">{mediumTasks}</p>
          </div>
        </div>
      </Col>
      <Col md={3}>
        <div onClick={() => filterTask("Low")} className="bento-card logo">
          <div className="bento-card-description">
            <h2>Low</h2>
            <p className="mediumcolor">{lowTasks}</p>
          </div>
        </div>
      </Col>

      {/* <Col md={3}>
        <Card className="text-center h-100 customcard">
          <Card.Body>
            <Card.Title>Top</Card.Title>
            <Card.Text className="display-4">{completedTasks}</Card.Text>
          </Card.Body>
        </Card>
      </Col> */}
      {/* <Col md={3}>
        <Card className="text-center h-100 customcard">
          <Card.Body>
            <Card.Title>High</Card.Title>
            <Card.Text className="display-4">{delayedTasks}</Card.Text>
          </Card.Body>
        </Card>
      </Col> */}

      {/* <Col md={3}>
        <Card className="text-center h-100 customcard">
          <Card.Body>
            <Card.Title>Medium</Card.Title>
            <Card.Text className="display-4">{delayedTasks}</Card.Text>
          </Card.Body>
        </Card>
      </Col> */}
    </Row>
  );
};

export default SummaryCards;
